<div>
  <div *ngIf="securityData">
    <div *ngIf="securityData.HeadersCheck?.HSTS" class="flex justify-start border-b pb-4 gap-4 items-center">
      <app-wordpress-check
        label="HSTS"
        [checked]="securityData.HeadersCheck.HSTS.pass"
      ></app-wordpress-check>
      <div>
        {{ securityData.HeadersCheck.HSTS.value }}
      </div>
    </div>
    <div *ngIf="securityData.HeadersCheck?.CSP" class="flex justify-start border-b pb-4 gap-4 items-center">
      <app-wordpress-check
        label="CSP"
        [checked]="securityData.HeadersCheck.CSP.pass"
      ></app-wordpress-check>
      <div>
        {{ securityData.HeadersCheck.CSP.value }}
      </div>
    </div>
    <div *ngIf="securityData.HeadersCheck['X-Frame-Options']" class="flex justify-start border-b pb-4 gap-4 items-center">
      <app-wordpress-check
        label="X-Frame-Options"
        [checked]="securityData.HeadersCheck['X-Frame-Options'].pass"
      ></app-wordpress-check>
      <div>
        {{ securityData.HeadersCheck['X-Frame-Options'].value }}
      </div>
    </div>
    <div *ngIf="securityData.HeadersCheck['X-Content-Type-Options']" class="flex justify-start border-b pb-4 gap-4 items-center">
      <app-wordpress-check
        label="X-Content-Type-Options"
        [checked]="securityData.HeadersCheck['X-Content-Type-Options'].pass"
      ></app-wordpress-check>
      <div>
        {{ securityData.HeadersCheck['X-Content-Type-Options'].value }}
      </div>
    </div>
  </div>
</div>
